import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  tipos_entradas: [],
  totalCount: 0,
}

export const Slice = createSlice({
  name: 'tiposEnt',
  initialState,
  reducers: {
    setTiposEntradas: (state, action) => {
      state.tipos_entradas = action.payload
    },
    setTotalCount: (state, action) => {
      state.totalCount = action.payload
    },
  },
})

export const { setTiposEntradas, setTotalCount } = Slice.actions
export default Slice.reducer
